import { cssVarName, type Palette } from './palettes';

const v = (path: string): string => `var(${cssVarName(path)})`;

/**
 * デザイントークン。値は CSS 変数の参照(var(--kdk-*))で、実際の色は palettes.ts の
 * ライト / ダークのどちらかが <html data-mui-color-scheme> に応じて入る。
 * 型を Palette にしてあるので、palettes.ts に足したキーをここに足し忘れるとコンパイルエラーになる。
 */
export const tokens: Palette = {
  bg: v('bg'),
  sidebar: v('sidebar'),
  sidebarTx: v('sidebarTx'),
  sidebarMu: v('sidebarMu'),
  sidebarDim: v('sidebarDim'),
  sidebarHover: v('sidebarHover'),
  sidebarActive: v('sidebarActive'),
  sidebarLine: v('sidebarLine'),
  sidebarLine2: v('sidebarLine2'),
  sidebarAccent: v('sidebarAccent'),
  panel: v('panel'),
  panel2: v('panel2'),
  drawer: v('drawer'),
  monthBand: v('monthBand'),
  line: v('line'),
  line2: v('line2'),
  tx: v('tx'),
  mu: v('mu'),
  dim: v('dim'),
  red: v('red'),
  ok: v('ok'),
  accent: v('accent'),
  blue: v('blue'),
  blueHover: v('blueHover'),
  rowHover: v('rowHover'),
  track: v('track'),
  inset: v('inset'),
  calendarGrid: v('calendarGrid'),
  chartGrid: v('chartGrid'),
  alertBorder: v('alertBorder'),
  marker: v('marker'),
  caseL: v('caseL'),
  scrollbar: {
    track: v('scrollbar-track'),
    thumb: v('scrollbar-thumb'),
    thumbHover: v('scrollbar-thumbHover'),
  },
  dest: { G: v('dest-G'), A: v('dest-A'), B: v('dest-B'), C: v('dest-C') },
  stage: {
    1: v('stage-1'),
    2: v('stage-2'),
    3: v('stage-3'),
    4: v('stage-4'),
    5: v('stage-5'),
  },
  load: {
    lo: v('load-lo'),
    ok: v('load-ok'),
    hi: v('load-hi'),
    over: v('load-over'),
    overTx: v('load-overTx'),
  },
  tentative: { bg: v('tentative-bg'), border: v('tentative-border'), tx: v('tentative-tx') },
  bar: { need: v('bar-need'), used: v('bar-used'), capacity: v('bar-capacity') },
  spark: { ok: v('spark-ok'), none: v('spark-none') },
};

export const FONT_BODY = "'BIZ UDPGothic','Hiragino Kaku Gothic ProN','Meiryo',sans-serif";
export const FONT_NUM = "'Barlow Semi Condensed','BIZ UDPGothic',sans-serif";
